'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _BaseIcon2 = require('./BaseIcon');

var _BaseIcon3 = _interopRequireDefault(_BaseIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint-disable */
var XCircle = function (_BaseIcon) {
  (0, _inherits3.default)(XCircle, _BaseIcon);

  function XCircle() {
    (0, _classCallCheck3.default)(this, XCircle);
    return (0, _possibleConstructorReturn3.default)(this, (XCircle.__proto__ || (0, _getPrototypeOf2.default)(XCircle)).apply(this, arguments));
  }

  (0, _createClass3.default)(XCircle, [{
    key: 'render',
    value: function render() {
      var svgColor = this.props.fill !== 'inherit' ? this.props.fill : '#AAB5BD';
      return _react2.default.createElement(
        'svg',
        this.getSvgProps(),
        _react2.default.createElement('path', { d: 'M9.76 0C4.38 0 0 4.38 0 9.76c0 5.37 4.38 9.75 9.76 9.75 5.37 0 9.75-4.3 9.75-9.7 0-5.4-4.3-9.8-9.7-9.8zm3.72 12.3c.34.33.34.88 0 1.22-.17.18-.4.26-.6.26-.23 0-.46-.08-.63-.26L9.75 11l-2.5 2.52c-.18.18-.4.26-.63.26-.22 0-.44-.08-.6-.26-.35-.34-.35-.9 0-1.23l2.5-2.6L6 7.22c-.35-.32-.35-.9 0-1.2.33-.3.88-.3 1.22 0l2.5 2.56L12.24 6c.35-.33.9-.33 1.24 0 .34.35.34.9 0 1.24l-2.5 2.53 2.5 2.52z', fill: svgColor })
      );
    }
  }]);
  return XCircle;
}(_BaseIcon3.default);
/*eslint-enable */


XCircle.defaultProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 20 20'
};
exports.default = XCircle;
//# sourceMappingURL=XCircle.js.map


//////////////////
// WEBPACK FOOTER
// ../icon/lib/Icons/XCircle.js
// module id = 332
// module chunks = 0